import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    width: 1.88,
    height: 2.14,
    viewBox: '83.04 15 345.93 482',
    defaultAriaLabel: 'Small Certificate Icon',
};

export const SmallCertificateIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="m428.965 187.966c0-95.374-77.592-172.966-172.965-172.966s-172.965 77.592-172.965 172.966c0 54.587 25.426 103.341 65.048 135.063v157.971c0 5.977 3.331 11.455 8.638 14.206 2.318 1.201 4.844 1.794 7.36 1.794 3.246 0 6.477-.986 9.227-2.927l79.864-56.356 79.863 56.356c4.884 3.445 11.28 3.882 16.587 1.133 5.307-2.751 8.638-8.229 8.638-14.206v-153.628c42.844-31.512 70.705-82.263 70.705-139.406zm-313.93 0c0-77.729 63.236-140.966 140.965-140.966s140.965 63.237 140.965 140.966-63.236 140.965-140.965 140.965-140.965-63.237-140.965-140.965zm211.225 262.161-63.863-45.065c-5.53-3.901-12.919-3.903-18.449 0l-63.864 45.065v-106.774c22.932 11.249 48.698 17.578 75.917 17.578 25.002 0 48.779-5.34 70.26-14.928v104.124z"></path>
        </SvgIcon>
    );
};
